const receiptFields = [
  { key: 'storeNumber', label: 'Store' },
  { key: 'date', label: 'Date' },
  { key: 'totalSubtotal', label: 'Subtotal' },
  { key: 'totalShipping', label: 'Shipping' },
  { key: 'totalTax', label: 'Tax' },
  { key: 'total', label: 'Total' },
];

//Accepts an object and return text file url
export const convertToTxtUrl = (json) => {
  const convertedText = receiptFields.map(({ key, label }) => `${label}: ${json[key]}`);
  const blob = new Blob([convertedText.join('\n')], { type: 'text/plain' });
  const txtFileUrl = window.URL.createObjectURL(blob);
  return txtFileUrl;
};

export const downloadDailyReport = (reportUrl) => {
  const link = document.createElement('a');
  link.href = reportUrl;
  link.click();
};

export const downloadReport = (report, storeId) => {
  const reportData = { storeNumber: storeId, ...report };
  const link = document.createElement('a');
  link.href = convertToTxtUrl(reportData);
  link.addEventListener('click', () => setTimeout(() => URL.revokeObjectURL(link.href)));
  link.download = `Daily Report - ${report?.date}.txt`;
  link.click();
};
